export function SectionScroll({ target, label, light = false }: { target: string; label: string; light?: boolean }) {
  return <button className={`section-scroll${light ? ' section-scroll--light' : ''}`} type="button" aria-label={`Scroll down to ${label}`} onClick={() => {
    const section = document.getElementById(target)
    if (!section) return
    const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom ?? 0
    window.scrollTo({ top: Math.ceil(window.scrollY + section.getBoundingClientRect().top - headerBottom), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })
    section.focus({ preventScroll: true })
  }}><span>{label}</span><span aria-hidden="true">↓</span></button>
}
